var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 394 132.3",
    style: {
      enableBackground: "new 0 0 394 132.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0AE2FF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "inter-est-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.2,90L69,80.2c5.7-2.5,10.1-7,12.5-12.8l9.9,4C87.9,79.7,81.4,86.4,73.2,90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,92.8c-18.8,0-34.1-15.3-34.1-34.1h10.6c0,13,10.5,23.5,23.5,23.5H60l0.1,10.6L59.7,92.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.5,50C76.7,37.9,63,32,51,36.8c-5.8,2.3-10.5,6.9-12.9,12.7l-9.9-4.2C35.5,28,55.6,19.9,72.9,27.2 c8.4,3.6,15,10.3,18.4,18.8L81.5,50z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.1,38.9c-9.4-14.6-27.9-20.4-44-14l-4-9.9c20.8-8.3,44.6-0.8,56.9,18L90.1,38.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,44.7l-9.8-4.1c2.4-5.7,5.8-10.8,10.2-15.1l7.5,7.5C30.7,36.3,28,40.3,26.2,44.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,105.5c-25.9-0.1-46.8-21-46.9-46.9c0-3.1,0.3-6.2,0.9-9.2l10.4,2.1c-0.5,2.4-0.7,4.7-0.7,7.1 c0,20,16.2,36.2,36.3,36.3c5,0,9.9-1,14.4-3l4.3,9.8C72.5,104.2,66.1,105.5,59.7,105.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.7,90.9L86,83.6c4.8-5,8-11.2,9.3-18l10.5,2C104,76.4,99.8,84.5,93.7,90.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,81.7C-8.1,51.3,6.3,16.3,36.7,3.6C40.5,2,44.5,0.8,48.6,0l2,10.5c-26.6,5.1-44.1,30.8-39,57.4 c0.6,3.3,1.6,6.6,2.9,9.7L4.6,81.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,114c-7.3-2.9-13.9-7.3-19.5-12.8l7.5-7.6c4.6,4.5,10,8.1,16,10.5L37.3,114z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,117.1l-2.2-10.4c16-3.3,29.4-14.4,35.5-29.6l9.9,4C107.6,99.5,91.4,113,71.9,117.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,40.5c-6-15.3-19.4-26.5-35.4-29.9L72,0.2c19.6,4.1,35.8,17.7,43.1,36.3L105.2,40.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.7,37.6h9.8v42.3h-9.8V37.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.9,61.3v18.6h-9.4V62.8c0-5.3-2.4-7.7-6.6-7.7c-4.5,0-7.8,2.8-7.8,8.8v16.1h-9.4V47.4h9v3.8 c2.8-2.9,6.7-4.4,10.7-4.3C175.1,46.9,180.9,51.4,180.9,61.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.2,78.3c-2.3,1.4-5,2.1-7.7,2c-7.7,0-12.1-3.9-12.1-11.6V55.4h-5v-7.2h5v-7.9h9.4v7.9h8.1v7.3h-8.1v13.2 c0,2.8,1.5,4.3,4,4.3c1.4,0,2.7-0.4,3.8-1.2L210.2,78.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246,66.3h-24.6c0.9,4,4.4,6.5,9.3,6.5c3,0.1,6-1,8.1-3.1l5,5.4c-3,3.4-7.5,5.3-13.4,5.3 c-11.2,0-18.5-7.1-18.5-16.7s7.4-16.7,17.3-16.7c9.5,0,16.9,6.4,16.9,16.9C246.2,64.5,246.1,65.5,246,66.3z M221.3,60.8h16 c-0.7-4.4-4.9-7.4-9.3-6.7C224.6,54.7,221.9,57.4,221.3,60.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.5,46.9v8.7c-0.8-0.1-1.4-0.1-2.1-0.1c-5.2,0-8.6,2.8-8.6,9v15.3h-9.4V47.4h9v4.3 C263.7,48.6,267.5,46.9,272.5,46.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.2,90L69,80.2c5.7-2.5,10.1-7,12.5-12.8l9.9,4C87.9,79.7,81.4,86.4,73.2,90z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,92.8c-18.8,0-34.1-15.3-34.1-34.1h10.6c0,13,10.5,23.5,23.5,23.5H60l0.1,10.6L59.7,92.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.5,50C76.7,37.9,63,32,51,36.8c-5.8,2.3-10.5,6.9-12.9,12.7l-9.9-4.2C35.5,28,55.6,19.9,72.9,27.2 c8.4,3.6,15,10.3,18.4,18.8L81.5,50z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.1,38.9c-9.4-14.6-27.9-20.4-44-14l-4-9.9c20.8-8.3,44.6-0.8,56.9,18L90.1,38.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,44.7l-9.8-4.1c2.4-5.7,5.8-10.8,10.2-15.1l7.5,7.5C30.7,36.3,28,40.3,26.2,44.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,105.5c-25.9-0.1-46.8-21-46.9-46.9c0-3.1,0.3-6.2,0.9-9.2l10.4,2.1c-0.5,2.4-0.7,4.7-0.7,7.1 c0,20,16.2,36.2,36.3,36.3c5,0,9.9-1,14.4-3l4.3,9.8C72.5,104.2,66.1,105.5,59.7,105.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,81.7C-8.1,51.3,6.3,16.3,36.7,3.6C40.5,2,44.5,0.8,48.6,0l2,10.5c-26.6,5.1-44.1,30.8-39,57.4 c0.6,3.3,1.6,6.6,2.9,9.7L4.6,81.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,114c-7.3-2.9-13.9-7.3-19.5-12.8l7.5-7.6c4.6,4.5,10,8.1,16,10.5L37.3,114z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,117.1l-2.2-10.4c16-3.3,29.4-14.4,35.5-29.6l9.9,4C107.6,99.5,91.4,113,71.9,117.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,40.5c-6-15.3-19.4-26.5-35.4-29.9L72,0.2c19.6,4.1,35.8,17.7,43.1,36.3L105.2,40.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.4,59.2h17.1v7.5h-17.1V59.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.8,66.3h-24.6c0.9,4,4.3,6.5,9.3,6.5c3,0.1,6-1,8.2-3.1l5,5.4c-3,3.4-7.5,5.3-13.4,5.3 c-11.2,0-18.5-7.1-18.5-16.7s7.4-16.7,17.3-16.7c9.5,0,16.9,6.4,16.9,16.9C335,64.5,334.8,65.5,334.8,66.3z M310.1,60.8h16 c-0.7-4.4-4.9-7.4-9.3-6.7C313.3,54.7,310.7,57.4,310.1,60.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338,76.9l3.1-6.8c3.4,2,7.3,3.1,11.3,3.1c4.3,0,6-1.1,6-3c0-5.3-19.6,0.1-19.6-12.9c0-6.2,5.6-10.5,15-10.5 c4.5,0,9.4,1,12.5,2.8l-3.1,6.7c-2.9-1.6-6.1-2.4-9.4-2.4c-4.2,0-6,1.3-6,3c0,5.5,19.6,0.2,19.6,13c0,6-5.6,10.3-15.3,10.3 C346.6,80.4,341,78.9,338,76.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394,78.3c-2.3,1.4-5,2.1-7.7,2c-7.7,0-12.1-3.9-12.1-11.6V55.4h-5v-7.2h5v-7.9h9.4v7.9h8.1v7.3h-8.1v13.2 c0,2.8,1.5,4.3,4,4.3c1.4,0,2.7-0.4,3.8-1.2L394,78.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.a99f3f42632e8209fd32c671457fde57.svg";
export { ForwardRef as ReactComponent };